// Frozen copy of main's code for the document_generation_v4_enabled / agency_brand_design_enabled flag-off path; delete with the flag.
import { Extension } from '@tiptap/core';
import type { Editor as EditorType } from '@tiptap/react';

export const SmartHighlightExtension = Extension.create({
  name: 'smartHighlight',

  addStorage() {
    return {
      getCurrentColor: (editor: EditorType): string => {
        const { state } = editor;
        const { selection } = state;
        const { $from, empty } = selection;

        const textBgColor = editor.getAttributes('textStyle').backgroundColor as string | undefined;
        if (!empty && textBgColor) {
          return textBgColor;
        }

        for (let depth = $from.depth; depth > 0; depth--) {
          const node = $from.node(depth);
          if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') {
            const cellBgColor = node.attrs.backgroundColor;
            if (cellBgColor) return cellBgColor;
          }
        }

        for (let depth = $from.depth; depth > 0; depth--) {
          const node = $from.node(depth);
          if (node.type.name === 'div') {
            const divBgColor = node.attrs.backgroundColor;
            if (divBgColor) return divBgColor;
          }
        }

        for (let depth = $from.depth; depth > 0; depth--) {
          const node = $from.node(depth);
          if (
            node.type.name === 'paragraph' ||
            node.type.name === 'heading' ||
            node.type.name === 'blockquote'
          ) {
            const blockBgColor = node.attrs.backgroundColor;
            if (blockBgColor) return blockBgColor;
          }
        }

        return '#ffffff';
      }
    };
  },

  addCommands() {
    return {
      setSmartBackgroundColor:
        (color: string) =>
        ({ commands, state, tr, dispatch }) => {
          const { selection } = state;
          const { empty } = selection;

          if (!empty) {
            return commands.setBackgroundColor(color);
          }

          const { $from } = selection;

          let tableCellDepth = -1;
          for (let depth = $from.depth; depth > 0; depth--) {
            const node = $from.node(depth);
            if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') {
              tableCellDepth = depth;
              break;
            }
          }

          if (tableCellDepth > 0) {
            const cellNode = $from.node(tableCellDepth);

            if (dispatch) {
              const pos = $from.before(tableCellDepth);
              const nodeAttrs = { ...cellNode.attrs, backgroundColor: color };
              tr.setNodeMarkup(pos, undefined, nodeAttrs);
              dispatch(tr);
              return true;
            }
            return true;
          }

          let divDepth = -1;
          for (let depth = $from.depth; depth > 0; depth--) {
            const node = $from.node(depth);
            if (node.type.name === 'div') {
              divDepth = depth;
              break;
            }
          }

          if (divDepth > 0) {
            const node = $from.node(divDepth);

            if (dispatch) {
              const pos = $from.before(divDepth);
              const nodeAttrs = { ...node.attrs, backgroundColor: color };
              tr.setNodeMarkup(pos, undefined, nodeAttrs);
              dispatch(tr);
              return true;
            }
            return true;
          }

          for (let depth = $from.depth; depth > 0; depth--) {
            const node = $from.node(depth);
            const nodeType = node.type.name;

            if (nodeType === 'paragraph' || nodeType === 'heading' || nodeType === 'blockquote') {
              if (dispatch) {
                const pos = $from.before(depth);
                const nodeAttrs = { ...node.attrs, backgroundColor: color };
                tr.setNodeMarkup(pos, undefined, nodeAttrs);
                dispatch(tr);
                return true;
              }
              return true;
            }
          }

          return false;
        },

      clearSmartBackgroundColor:
        () =>
        ({ commands, state, tr, dispatch }) => {
          const { selection } = state;
          const { empty } = selection;

          if (!empty) {
            return commands.unsetBackgroundColor();
          }

          const { $from } = selection;

          let tableCellDepth = -1;
          for (let depth = $from.depth; depth > 0; depth--) {
            const node = $from.node(depth);
            if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') {
              tableCellDepth = depth;
              break;
            }
          }

          if (tableCellDepth > 0) {
            const cellNode = $from.node(tableCellDepth);

            if (dispatch) {
              const pos = $from.before(tableCellDepth);
              const nodeAttrs = { ...cellNode.attrs, backgroundColor: null };
              tr.setNodeMarkup(pos, undefined, nodeAttrs);
              dispatch(tr);
              return true;
            }
            return true;
          }

          let divDepth = -1;
          for (let depth = $from.depth; depth > 0; depth--) {
            const node = $from.node(depth);
            if (node.type.name === 'div') {
              divDepth = depth;
              break;
            }
          }

          if (divDepth > 0) {
            const node = $from.node(divDepth);

            if (dispatch) {
              const pos = $from.before(divDepth);
              const nodeAttrs = { ...node.attrs, backgroundColor: null };
              tr.setNodeMarkup(pos, undefined, nodeAttrs);
              dispatch(tr);
              return true;
            }
            return true;
          }

          for (let depth = $from.depth; depth > 0; depth--) {
            const node = $from.node(depth);
            const nodeType = node.type.name;

            if (nodeType === 'paragraph' || nodeType === 'heading' || nodeType === 'blockquote') {
              if (dispatch) {
                const pos = $from.before(depth);
                const nodeAttrs = { ...node.attrs, backgroundColor: null };
                tr.setNodeMarkup(pos, undefined, nodeAttrs);
                dispatch(tr);
                return true;
              }
              return true;
            }
          }

          return false;
        }
    };
  }
});
